import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompare = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M25.5 16.064h9.815v-3h-22.63v3H22.5v23.311h-6.157v3h15.315v-3H25.5zm-3-10.439h3V11.2h-3z" }), /* @__PURE__ */ _jsx("path", { d: "m35.901 17.671-7.658 13.162 7.658 3.031 7.658-3.031zm-3.312 11.656 3.312-5.691 3.312 5.691-3.312 1.311zM12.1 17.671 4.442 30.833l7.658 3.031 7.658-3.031zM8.788 29.327l3.311-5.691 3.312 5.691-3.311 1.311z" })] }) })
});
export default SvgCompare;
